// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext, useRef} from 'react';
import cn from 'classnames';
import {use_translation_v} from '../../lib/trans_v';
import {Settings_context} from '../../settings_ctx';
import {use_section_scroll} from '../../lib/use_section_scroll';
import {use_expand_animation} from '../use_expand_animation';
import {Link} from '../link';
import zutil from 'zutil';
import hopt from 'hola_opt';
import {Install_btn} from '../install_btn';
import {guess_os_and_version} from '../../client_hints_global';
import './hola_start.module.less';

const Nbsp = ()=><Fragment>&nbsp;</Fragment>;

export const Hola_start = ({version = 1, dark, purple, user_country})=>{
    const {theme} = useContext(Settings_context);
    const r = useRef();
    const r1 = useRef();
    const r2 = useRef();
    const {T} = use_translation_v();
    const cls = cn('hola_start', version && `version${version}`, {dark},
        version==4 && `${theme.container} ${theme.block}`);
    const header_cls = cn('hola_start-header',
        `hola_start-header--version_${version}`);
    const btn_cls = cn('hola_btn hola_btn--lg hola_btn--round',
        [3, 4].indexOf(version)<0 && 'hola_start-add',
        version==3 && 'hp_btn_ver3',
        purple && 'hola_btn-no_arrow',
        version==4 && 'hola_btn--txt_colored hola_btn--no_jump');
    const sys = guess_os_and_version();
    const cta_text = version==4 && sys.mobile ? 'Download Hola today!'
        : version==3 ? 'Get Hola'
        : null;
    use_expand_animation(r, [r1, r2], {shift: 0, no_fadeout: version==4});
    const anim = zutil.get(hopt, `www_hola.animation.hola_start.v${version}`,
        {});
    use_section_scroll(r, version!=4, anim);
    return <div className={cls} ref={r}>
      <div className={header_cls} ref={r1}>
        {version==4 && <Fragment>
          <h2><T i18nKey="hp.hola_start.v4.title" components={{br: <br/>}}/></h2>
        </Fragment>}
        {version==3 && <Fragment>
          <span>Personal. Protected. Private.</span><br/>
          Don't miss out, secure your connection now!
        </Fragment>}
        {version==2 && <Fragment>
          <span><span className="monospace multicolor"><T
            i18nKey="hp.hero.subtitle"
            components={{Nbsp: <Nbsp/>, span: <span/>}}/></span></span><br/>
          <T>Don't miss out, start watching now!</T>
        </Fragment>}
        {version==1 && <Fragment>
          Fast. Effective. Free. It's worth a try!<br/>
          Start watching now
        </Fragment>}
      </div>
      {version==3 ? <Link className={btn_cls} to="/premium?ref=hola_start">
        <span>{cta_text}</span>
      </Link> : <Install_btn className={btn_cls} src="hola_start_btn"
        user_country={user_country} text={cta_text} ref={r2}
        keep_btn_text={!!cta_text}/>}
    </div>;
};
